import type { ReactNode } from 'react';
import { DynamicIcon } from 'src/components';
import {
  PlansCounterChip,
  SectionAccordion,
  SectionAccordionDetails,
  SectionAccordionSummary,
  SectionSummaryContent,
  SectionSummaryTitle,
} from 'src/pages/Settings/memberships/components/plans-tab/styled';

const archivedTitleSx = { fontSize: '0.875rem' } as const;

const archivedDetailsSx = { pl: 2, pr: 2, pb: 1 } as const;

type ArchivedPlansSectionProps = {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  count: number;
  children?: ReactNode;
};

export const ArchivedPlansSection = ({
  expanded,
  onExpandedChange,
  count,
  children,
}: ArchivedPlansSectionProps): React.JSX.Element => (
  <SectionAccordion
    elevation={0}
    expanded={expanded}
    slotProps={{ transition: { mountOnEnter: true, unmountOnExit: true } }}
    onChange={(_, expandedValue) => {
      onExpandedChange(expandedValue);
    }}
    disableGutters
    data-testid="archived-plans-section"
  >
    <SectionAccordionSummary
      expandIcon={<DynamicIcon name="chevron-right" library="lucide" />}
    >
      <SectionSummaryContent>
        <SectionSummaryTitle variant="subtitle2" sx={archivedTitleSx}>
          Archived
        </SectionSummaryTitle>
        <PlansCounterChip label={`${count}`} size="small" />
      </SectionSummaryContent>
    </SectionAccordionSummary>

    <SectionAccordionDetails sx={archivedDetailsSx}>{children}</SectionAccordionDetails>
  </SectionAccordion>
);
